import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';

Vue.use(VueRouter);

const routes = [
  {
    path: '/b/:bookId',
    name: 'Booked',
    component: () => import(/* webpackChunkName: "Booked" */ '@/views/Booked.vue'),
  },
  {
    path: '/:brandId',
    name: 'Brand',
    component: () => import(/* webpackChunkName: "Brand" */ '@/views/Brand.vue'),
  },
  {
    path: '/:brandId/:storeId',
    name: 'Store',
    component: () => import(/* webpackChunkName: "Brand" */ '@/views/Store.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.query.s) {
    Cookies.set('s', to.query.s, { path: '/' });
    const newTo = to;
    delete newTo.query.s;
    next(newTo);
  }
  next();
});

export default router;
